import React from "react";
import desktopImg from "../images/process/processdesktop.png";   // horizontal image
import mobileImg from "../images/process/processmobile.jpg";     // vertical image

const HomeourProcess = () => {
  return (
    <div className="process-banner">
      <picture>
        {/* MOBILE IMAGE */}
        <source media="(max-width: 768px)" srcSet={mobileImg} />

        {/* DESKTOP IMAGE */}
        <img src={desktopImg} alt="Our Process" className="banner-img" />
      </picture>

      <style>{`
            .process-banner {
            width: 100%;
            position: relative;
            }

            /* DEFAULT (MOBILE FIRST) */
            .banner-img {
            width: 100%;
            height: auto;
            display: block;
            object-fit: contain;
            }

            /* TABLET */
            @media (max-width: 900px) {
            .banner-img {
                object-fit: contain;
            }
            }

            /* MOBILE */
            @media (max-width: 768px) {
            .banner-img {
                object-fit: contain;
                max-height: none;
            }
            }

            /* 💻 LAPTOP / DESKTOP ONLY */
            @media (min-width: 1024px) {
            .banner-img {
                height: 500px;        /* ✅ your requirement */
                object-fit: cover;    /* keeps it looking good */
            }
            }
            `}</style>
    </div>
  );
};

export default HomeourProcess;